export default "__VITE_ASSET__BhwvvoS3__"